import axios from 'axios';
import History from 'components/history';
import Observer from 'common/scripts/observer';
import ParametricFilter from './templates/filter';
import ParametricMap from './templates/map';
import ParametricResult from './templates/result';
import {Utils} from 'common/scripts/utils';

const observer = new Observer();

class Parametric {
    constructor(options) {
        this.options = options;
        this.element = options.element;

        this.filter = null;
        this.result = null;
    }

    init() {
        this._initFilter();
        this._initResult();
        this._initMap();
    }

    /**
     * Инит фильтров
     * @private
     */
    _initFilter() {
        this.filter = new ParametricFilter({
            element: this.element,
            change : (reqType, addData) => {
                this._send(reqType, addData);
            }
        });

        this.filter.init();
    }

    /**
     * Инициализация результатов
     * @private
     */
    _initResult() {
        this.result = new ParametricResult({
            element   : this.element,
            changeSort: (data) => {
                this._send('sort', data);
            },
            clickMore: (data) => {
                this._send('more', data);
            },
            resetFull: () => {
                this._send('resetFull');
            }
        });

        this.result.init();
    }

    /**
     * Инициализация карты
     * @private
     */
    _initMap() {
        this.map = new ParametricMap({
            element: this.element
        });

        this.map.init();
    }

    /**
     * Запрос на сервер
     * @param {string} reqType - тип запроса
     * @param {object} additionalData - дополнительные данные
     * @private
     */
    /* eslint-disable */
    _send(reqType, additionalData = {}) {
        const form = this.filter.getForm() || this.result.getFormData();
        const formData = form && Utils.isElement(form) ? new FormData(form) : new FormData();

        formData.append('req_type', reqType);

        if (!Utils.isElement(form)) {
            const exact = ['action', 'method'];

            for (const key in form) {
                if (Object.prototype.hasOwnProperty.call(form, key) && exact.indexOf(key) === -1) {
                    formData.append(key, form[key]);
                }
            }
        }

        this._addAdditionalData(formData, additionalData);
        this.filter.convertRanges(formData);

        // for (const pair of formData.entries()) {
        //     console.log(pair[0]+ ', ' + pair[1]);
        // }

        // Действия перед отправкой запроса
        switch (reqType) {
            case 'filter':
                this.filter.runLoading(true);
                break;
            case 'reset':
                this._resetUrl();
                this.filter.runLoading(true);
                break;
            case 'resetFull':
                this._resetUrl();
                this.filter.runLoading(true);
                this.result.runLoading();
                this.map.runLoading();
                break;
            case 'show':
                this._resetUrl();
                this.filter.runLoading();
                this.result.runLoading();
                this.map.runLoading();
                History.appendFromFormData(formData);
                break;
            case 'sort':
                this.result.runLoadingComplex();
                break;
            case 'more':
                this.result.runLoadingComplex(true);
                break;
            default:
                break;
        }

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios[form.method](form.action, formData)
            .then((response) => {
                const {data, request} = response.data;

                if (!request.status) {
                    throw new Error(request.errors.length ? request.errors : 'Ошибка на сервере');

                    return;
                }

                const searchParams = new URLSearchParams(formData).toString();

                switch (reqType) {
                    case 'sort':
                        this.result.setSortResult(data);
                        break;
                    case 'more':
                        this.result.setMoreResult(data);
                        this._sendCriteo(data, reqType);
                        break;
                    case 'filter':
                        this.filter.setFilter(data, reqType);
                        this.filter.setHref(searchParams);
                        break;
                    case 'reset':
                        this.filter.setFilter(data, reqType);
                        this.filter.setHref(searchParams);
                        observer.publish('parametric:filterReset');
                        break;
                    case 'resetFull':
                        this.filter.setFilter(data, reqType);
                        this.filter.setHref(searchParams);
                        observer.publish('parametric:filterReset');
                        this.map.setMap(data);
                        this.result.setResult(data);
                        this.result.scrollToTop();
                        break;
                    case 'show':
                        this.map.setMap(data);
                        this.filter.setResult();
                        this.result.setResult(data);
                        this.result.scrollToTop();
                        this._sendCriteo(data, reqType);
                        break;
                    default:
                        break;
                }
            })
            .catch((error) => { // eslint-disable-line
                console.error(error); // eslint-disable-line
            })
            .then(() => {
                this.filter.stopLoading();
                this.result.stopLoading();
                this.result.stopLoadingComplex();
                this.map.stopLoading();
            });
    }
    /* eslint-enable */

    /**
     * Добавляет дополнительные данные в формдату
     * @param {object} formData - formData
     * @param {object} data - объект доп. данных (может содержать формдату)
     * @private
     */
    _addAdditionalData(formData, data) {
        if (!data) {
            return;
        }

        Object.keys(data).forEach((key) => {
            if (data[key] instanceof FormData) {
                data[key].forEach((v, k) => {
                    formData.append(k, v);
                });
            } else if (data[key] instanceof Array) {
                data[key].forEach((el) => {
                    formData.append(key, el);
                });
            } else {
                formData.append(key, data[key]);
            }
        });
    }

    /**
     * Очищает url от параметров
     * @private
     */
    _resetUrl() {
        History.clear();
    }

    /**
     * Отправляет данные в Criteo при обновлении результатов поиска / списка квартир после "показать еще"
     * ID квартир нужны в формате: ['ProductID_1', 'ProductID_2', 'ProductID_3']
     * @param {object} data - объект данных (может содержать формдату)
     * @param {string} reqType - тип запроса
     * @private
     */
    _sendCriteo(data, reqType) {
        const {complexes, flats} = data;

        switch (reqType) {
            case 'more':
                this._collectFlatsData(flats);
                break;
            case 'show':
                this._collectComplexesData(complexes);
                break;
            default:
                break;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'crto_listingpage',
            crto : {
                email   : '',
                products: Object.values(this.flatsIdArray)
            }
        });
    }

    /**
     * Собирает id квартир
     * @param {object} flats - массив квартир
     * @private
     */
    _collectFlatsData(flats) {
        this.flatsIdArray = [];

        flats.forEach((flat) => {
            this.flatsIdArray.push(flat.id);
        });
    }

    /**
     * Собирает квартиры из комплексов
     * @param {object} complexes - массив объектов
     * @private
     */
    _collectComplexesData(complexes) {
        const complexesFlatsArr = [];

        complexes.forEach((complex) => {
            complexesFlatsArr.push(...complex.flats);
        });

        this._collectFlatsData(complexesFlatsArr);
    }
}

export default Parametric;
